
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';
import { useQuery } from '@tanstack/react-query';
import { useUser } from '@supabase/auth-helpers-react';

export const HomeHeader = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const user = useUser();
  
  const { data: userData } = useQuery({
    queryKey: ['user', user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('users')
        .select('full_name')
        .eq('user_id', user?.id)
        .maybeSingle();
      
      if (error) {
        console.error('Error fetching user:', error);
        throw error;
      }
      return data;
    },
    enabled: !!user
  });

  return (
    <div className="pt-[8px]">
      <div className="flex justify-between items-center py-0">
        <h1 className="text-2xl font-bold">
          Your Events
        </h1>
      </div>
    </div>
  );
};
